// TODO: REMOVE THESE AS THEY SHOULD BE HANDLED BY @shared/utils.locale, but they introduce more file changes which makes it hard to review
export const localeToStore = {
  "en-GB": "en",
  "en-US": "us"
};

export const localeToRegion = {
  "en-GB": "uk",
  "en-US": "us"
};

export const storeToLocaleMap = {
  us: "en-US",
  en: "en-GB"
};
